import { useHistory } from 'react-router-dom';
import ButtonDialog from 'components/button-dialog';
import { useEffect } from 'react';
import amplitude from 'service/amplitude';

const ScanPaymentDialog = ({ data, onRefresh, setData }) => {
  const history = useHistory();

  useEffect(() => {
    if (data !== null) {
      amplitude.scanpay_dialog_pageview(data.type);
    }
  }, [data]);

  const dialogContent = type => {
    switch (type) {
      case 'popup_board':
        return {
          title: data.title,
          message: data.content,
          buttonList: [
            {
              theme: 'positive',
              content: data.buttonText,
              onClick: () => {
                setData(null);
              },
            },
          ],
        };
      case 'hint_board':
        return {
          image: data.image,
          title: data.title,
          message: data.content,
          buttonList: data.buttons.map(item => {
            return {
              theme: item.theme,
              content: item.content,
              onClick: () => {
                if (item.theme === 'positive' && data.action) {
                  return data.action();
                }

                setData(null);
              },
            };
          }),
        };
      case 'fetch_fail':
        return {
          title: '條碼讀取失敗',
          message: data.content,
          direction: 'horizonal',
          buttonList: [
            {
              theme: 'positive',
              content: '關閉',
              onClick: () => {
                history.goBack();
                setData(null);
              },
            },
          ],
        };
      case 'times_up':
        return {
          title: '條碼已過期',
          message: '您的交易條碼已過期，請點擊「更新條碼」重試。',
          direction: 'horizonal',
          buttonList: [
            {
              theme: 'positive',
              content: '更新條碼',
              onClick: () => {
                onRefresh();
                setData(null);
              },
            },
            {
              theme: 'cancel',
              content: '關閉',
              onClick: () => {
                history.goBack();
                setData(null);
              },
            },
          ],
        };
      case 'payment_timeout':
        return {
          title: '交易逾時',
          message: '交易結果以現場 POS 機為主，請與站員確認。',
          buttonList: [
            {
              theme: 'positive',
              content: '關閉',
              onClick: () => {
                setData(null);
                history.goBack();
              },
            },
          ],
        };
      case 'payemnt_fail':
        return {
          title: '交易失敗',
          message: data.content || '付款卡片請款失敗，請更換卡片後重試，或改用現場其他付款方式。',
          buttonList: [
            {
              theme: 'positive',
              content: '關閉',
              onClick: () => {
                setData(null);
                history.goBack();
              },
            },
          ],
        };
      default:
        return '';
    }
  };

  let dialogData = dialogContent(data?.type);

  return (
    <ButtonDialog
      image={dialogData.image}
      title={dialogData.title}
      items={dialogData.buttonList}
      isShow={dialogData !== ''}
    >
      {dialogData.message}
    </ButtonDialog>
  );
};

export default ScanPaymentDialog;
